import { render, staticRenderFns } from "./PromotionHeader.vue?vue&type=template&id=0291b2ff"
import script from "./PromotionHeader.vue?vue&type=script&lang=js"
export * from "./PromotionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports